import React from 'react';
import { Spin, Typography } from 'antd';

const { Text } = Typography;

interface LoadingSpinnerProps {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  fullScreen?: boolean;
  style?: React.CSSProperties;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'large',
  tip,
  fullScreen = false,
  style,
}) => {
  if (fullScreen) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255,255,255,0.8)',
          zIndex: 9999,
          ...style,
        }}
      >
        <Spin size={size} tip={tip}>
          <div style={{ padding: 50 }} />
        </Spin>
        {tip && <Text style={{ marginTop: 16 }}>{tip}</Text>}
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: 40, ...style }}>
      <Spin size={size} tip={tip}>
        <div style={{ padding: 50 }} />
      </Spin>
      {tip && <Text type="secondary" style={{ marginTop: 8, display: 'block' }}>{tip}</Text>}
    </div>
  );
};

export default LoadingSpinner;
